import React from "react";
import { FaCloud, FaShieldAlt, FaPassport, FaGlobe, FaFileSignature } from "react-icons/fa";

const tiles = [
  {
    icon: (
    <img
      src="/elmis.png"
      alt="Musaned"
      style={{ width: 105, height: 75, objectFit: "contain" }}
    />
  ),
    //title: "E-LMIS",
    link: "https://lmis.gov.et/auth",
    desc: "Ethiopian labor market information system"
  },
  {
  icon: (
    <img
      src="/musaned.png"
      alt="Musaned"
      style={{ width: 105, height: 55, objectFit: "contain" }}
    />
  ),
  title: "Musaned",
  link: "https://tawtheeq.musaned.com.sa/",
  desc: "Domestic labor service portal"
},  
{
    icon: (
    <img
      src="/enjaz.png"
      alt="Visa Mofa"
      style={{ width: 105, height: 75, objectFit: "contain" }}
    />
  ),
    title: "Visa Mofa",
    link: "https://visa.mofa.gov.sa/Account/Login/enjazcompany",
    desc: "Visa inquiry services"
  },
  {
    icon: (
    <img
      src="/wafid.png"
      alt="Wafid"
      style={{ width: 105, height: 75, objectFit: "contain" }}
    />
  ),
    title: "Wafid",
    link: "https://wafid.com/book-appointment/",
    desc: "Medical status verification system"
  },
  {
    icon: (
    <img
      src="/nyala.png"
      alt="Nyala"
      style={{ width: 105, height: 75, objectFit: "contain" }}
    />
  ),
    title: "Nyala",
    link: "https://agency.niscofetap.com/certificate/draft",
    desc: "Nyala Insurance S.C. (NISCO)"
  },
  {
    icon: (
    <img
      src="/cocf.png"
      alt="Federal COC"
      style={{ width: 105, height: 65, objectFit: "contain" }}
    />
  ),
    title: "Federal COC",
    link: "https://lmis.gov.et/coc-check",
    desc: "Certificates of Conformity"
  },
  {
    icon: (
    <img
      src="/coco.png"
      alt="Oromia COC"
      style={{ width: 105, height: 65, objectFit: "contain" }}
    />
  ),
    title: "Oromia COC",
    link: "https://verify.ococ.gov.et/",
    desc: "Certificates of Conformity"
  },
  {
    icon: (
    <img
      src="/cocamh.png"
      alt="Amhara COC"
      style={{ width: 105, height: 65, objectFit: "contain" }}
    />
  ),
    title: "Amhara COC",
    link: "https://www.amharacoc.gov.et/code/certificate.html",
    desc: "Certificates of Conformity"
  }
  /*,
  {
    icon: (
    <img
      src="/cocswe.png"
      alt="S.W.E.P.R.S"
      style={{ width: 105, height: 65, objectFit: "contain" }}
    />
  ),
    title: "S.W.E.P.R.S COC",
    link: "https://www.southwestcoc.gov.et/COC1/checkcertificate1.php",
    desc: "Certificates of Conformity"
  },
  {
    icon: (
    <img
      src="/coccnt.png"
      alt="Central Ethopia Region"
      style={{ width: 105, height: 65, objectFit: "contain" }}
    />
  ),
    title: "Central Ethopia Region COC",
    link: "https://cercocgovet.com/certificate-confirmation/",
    desc: "Certificates of Conformity"
  }*/
  //,{
  //  icon: <FaShieldAlt size={55} />,
  //  title: "Musaned",
  //  link: "https://www.musaned.com.sa",
  //  desc: "Domestic labor service portal"
  //}
];

export default function ServiceTiles() {
  return (
    <div className="w-full py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container">
        <div className="row g-4 justify-content-center text-center">
          {tiles.map((item, i) => (
            <div
              key={i}
              //className="col-6 col-md-4 col-lg-2 p-3 rounded shadow-sm"
              className="col-6 col-md-4 col-lg-2 p-3 rounded shadow-sm mx-2 my-3"
              style={{
                cursor: "pointer",
                transition: "all .3s",
                backgroundColor: "#ffffff",
              }}
              onClick={() => window.open(item.link, "_blank")}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = "0 10px 18px rgba(0,0,0,0.15)";
                e.currentTarget.style.backgroundColor = "#deebfabf";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0px)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.07)";
                e.currentTarget.style.backgroundColor = "#ffffff";
              }}
            >
              <div style={{ color: "#ffc414" }}>{item.icon}</div>
              <h5 className="mt-3 mb-1" style={{ fontWeight: "600" }}>{item.title}</h5>
              <p style={{ fontSize: "13px", color: "#555" }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
